import 'intersection-observer'
import { QLifeHeaderBidding } from './qlife-header-bidding'

if (window.QLife_hb_config) {
    QLifeHeaderBidding.start(window.QLife_hb_config)
}
